// contexts/MapContext.js
import React, { createContext, useContext, useCallback } from 'react'

const MapContext = createContext(null)

export function MapProvider({ children }) {
  const [mapInstance, setMapInstance] = React.useState(null)

  const setMap = useCallback((map) => {
    setMapInstance(map)
  }, [])

  const focusOnLocation = useCallback((latitude, longitude, zoom = 17) => {
    if (mapInstance) {
      mapInstance.panTo({ lat: latitude, lng: longitude })
      mapInstance.setZoom(zoom)
    }
  }, [mapInstance])

  return (
    <MapContext.Provider value={{ setMap, focusOnLocation }}>
      {children}
    </MapContext.Provider>
  )
}

export function useMap() {
  const context = useContext(MapContext)
  if (!context) {
    throw new Error('useMap must be used within a MapProvider')
  }
  return context
}